import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, listInfo, remove, scrollInfo } from 'kapix-components-vue3'
import lexiqueStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'lexique'
const customImplement: CustomStoreImplementationOptions = lexiqueStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function lexiqueFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('lexique.title', 'Lexique'),
        $description: $translate('lexique.description', 'Découvrez le lexique Matchers dédié à la formation professionnelle ! Éclaircissez vos doutes sur les termes clés du monde de la formation et optimisez votre compréhension pour naviguer aisément dans l\'univers de la formation professionnelle.'),
        $publishedTime: new Date('2023-04-24T12:22:46.657Z'),
        $modifiedTime: new Date('2023-09-01T08:49:35.979Z'),
        // Constants,
        $constants: {},
        // Data,
        $data: {
          previewLexicon: [
            {
              id: 1,
              Lien: 'https://www.matchers.fr/lexique/opco-afdas',
              Description: 'L\'Afdas intervient dans les secteurs de la culture, des industries créatives, des médias, de la communication, des télécommunications, du...',
              Titre: 'Afdas'
            },
            {
              id: 2,
              Lien: 'https://www.matchers.fr/lexique/opco-atlas',
              Description: 'L\'OPCO Atlas intervient dans les secteurs des services financiers et du conseil. Elle accompagne 13 branches professionnelles réunies en...',
              Titre: 'Atlas'
            },
            {
              id: 3,
              Lien: 'https://www.matchers.fr/lexique/budget-formation-entreprise',
              Description: 'Le budget formation correspond à une allocation financière prévue par l\'entreprise pour couvrir les coûts liés au développement...',
              Titre: 'Budget formation en entreprise'
            },
            {
              id: 4,
              Description: 'La convention collective est un accord écrit négocié entre les syndicats de salariés et d’employeurs. Il allie le droit du travail...',
              Titre: 'Convention collective '
            },
            {
              id: 5,
              Lien: 'Lexique/formation-inter-entreprise',
              Description: 'Parmi les différentes organisations de sessions de formation existent les formations inter-entreprise. Elles réunissent plusieurs salariés de...',
              Titre: 'Formation inter-entreprise'
            },
            {
              id: 6,
              Lien: 'Lexique/formation-intra-entreprise',
              Description: 'Les forma­tions intra-entre­prise sont des forma­tions exclu­si­ve­ment délivrées à un groupe de salariés appar­te­nant à la même entreprise, idéalement...',
              Titre: 'Formation intra-entreprise'
            },
            {
              id: 7,
              Description: 'Les formations professionnelles sont des formations permettant d\'acquérir les compétences, connaissances et le savoir-faire spécifiques à...',
              Titre: 'Formation professionnelle'
            },
            {
              id: 8,
              Description: 'La formation-action est basée sur l’action de ses participants : résolution d’une problématique, mise en place d’un...',
              Titre: 'Formation-action'
            },
            {
              id: 9,
              Description: 'Apparue le 1er janvier 2019 suite à l\'adoption de la loi pour la liberté de choisir son avenir professionnel du 5 septembre 2018, France Compétences...',
              Titre: 'France Compétences'
            },
            {
              id: 10,
              Lien: '/lexique-opcommerce',
              Description: `L'Opcommerce, l'un des 11 opérateurs de compétences, intervient auprès des entreprises du commerce, soit 20 branches professionnelles...

`,
              Titre: 'Opcommerce'
            },
            {
              id: 11,
              Description: 'Correspondant plus à une stratégie qu’à un dispositif (tel que le plan de développement des compétences), le plan de formation permet...',
              Titre: 'Plan de formation'
            }
          ] as PartialEntities<Kapix.Entity.IPreviewLexique>
        },
        $info: {
          lexique: scrollInfo(),
          list: listInfo<Kapix.Entity.IPreviewLexique>()
        },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return lexiqueFactory(storeId)()
}

export const lexiqueRaw = lexiqueFactory()
export const lexique = () => lexiqueRaw() as MergeCustomStore<typeof lexiqueStoreCustom.instance>
